import { Controller } from "@hotwired/stimulus"

// Reports the first interaction with an assigned test (product analytics: "started").
// Sends one POST per page view; failures are ignored — tracking must never block the test.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sent = false
    this.handler = () => this.send()
    this.element.addEventListener("change", this.handler, { capture: true })
    this.element.addEventListener("input", this.handler, { capture: true })
    this.element.addEventListener("click", this.clickHandler = (event) => {
      if (event.target.closest("input, button, label, [role='button'], [data-action]")) this.send()
    }, { capture: true })
  }

  disconnect() {
    this.element.removeEventListener("change", this.handler, { capture: true })
    this.element.removeEventListener("input", this.handler, { capture: true })
    this.element.removeEventListener("click", this.clickHandler, { capture: true })
  }

  send() {
    if (this.sent || !this.urlValue) return
    this.sent = true
    const token = document.querySelector("meta[name='csrf-token']")?.content
    try {
      fetch(this.urlValue, {
        method: "POST",
        keepalive: true,
        credentials: "same-origin",
        headers: { "X-CSRF-Token": token || "", "Accept": "application/json" }
      }).catch(() => {})
    } catch (_e) {
      // ignore
    }
  }
}
